import { Injector } from '@angular/core';
import { BaseNode } from '../BaseNode';
import { FormlyView } from '../../Data/FormlyView';
import { DummyNode } from '../DummyNode';
import { CONTAINSOPERATOR } from '../../Constants';
import { HierarchyMode, MeddraLevel } from '../../MeddraEnum';
import { EntityEnum } from '../EntityEnum';
import { Art57Section } from '../../Art57Section/Art57Section';
import { Art57NodeUtils } from '../Art57Node/Art57NodeUtils';

export class MeddraNode extends BaseNode {
  entityName: string;
  entityNode!: BaseNode|null;
  hierarchyMode: HierarchyMode | undefined;
  operatorSelected: string = CONTAINSOPERATOR;

  constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, entityNode: BaseNode|null,parent: BaseNode|undefined, hierarchyMode?: HierarchyMode | undefined) {
    super(injector, data, labelTemplate);
    this.hierarchyMode = hierarchyMode;
    this.entityName = entityName;
    this.entityNode = entityNode;
    if (parent) {
      this.parent = parent;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
    }
    
    if ((hierarchyMode != undefined)
      && (data instanceof FormlyView)
      && (!((hierarchyMode === HierarchyMode.ASCENDING && this.entityName === EntityEnum.soc) ||
        (hierarchyMode === HierarchyMode.DESCENDING && this.entityName === EntityEnum.llt)))) {
      this.children?.push(new DummyNode());
    }
  }

  override refreshLabel(lazy?: boolean): void {
    this.label = this.labelTemplate.replace("{param}", this.data.model ? this.data.model.length : 0);
  }

  getEntityNode(): BaseNode|null {
    return this.entityNode;
  }

}

export { MeddraLevel, HierarchyMode };
